import React, { FC } from 'react';
import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Report, useGetScalingSize } from '@ui/Report';
import { REPORT_PAGE_TITLE } from '../EditablePageHeader/editable-page-header.constants';
import {
  METHODOLOGY_SECTIONS,
  METHODOLOGY_TEXT,
  METHODOLOGY_TITLE,
} from './report-methodology.constants';

const { Page, Text } = Report;

const textSx = {
  display: 'block',
  margin: 0,
  fontFamily: '"Roboto", sans-serif',
  lineHeight: METHODOLOGY_TEXT.lineHeight,
  color: METHODOLOGY_TEXT.color,
} as const;

/** Static method description, rendered as the last page of the report. */
export const ReportMethodology: FC = () => {
  const getScalingSize = useGetScalingSize();
  const { classes } = useStyles({ getScalingSize });

  return (
    <Page verticalAlign="top">
      <Text
        as="h1"
        fontSize={REPORT_PAGE_TITLE.fontSize}
        fontWeight={REPORT_PAGE_TITLE.fontWeight}
        sx={{
          ...textSx,
          fontFamily: REPORT_PAGE_TITLE.fontFamily,
          lineHeight: REPORT_PAGE_TITLE.lineHeight,
          color: REPORT_PAGE_TITLE.color,
        }}
      >
        {METHODOLOGY_TITLE}
      </Text>
      <Box className={classes.columns}>
        {METHODOLOGY_SECTIONS.map((section) => (
          <Box key={section.heading} className={classes.section}>
            <Text
              as="h2"
              fontSize={METHODOLOGY_TEXT.headingFontSize}
              fontWeight={700}
              sx={{
                ...textSx,
                marginBottom: getScalingSize(METHODOLOGY_TEXT.paragraphGap),
              }}
            >
              {section.heading}
            </Text>
            {section.paragraphs.map((paragraph, index) => (
              <Text
                key={paragraph}
                as="p"
                fontSize={METHODOLOGY_TEXT.bodyFontSize}
                textAlign="justify"
                sx={{
                  ...textSx,
                  marginBottom:
                    index < section.paragraphs.length - 1
                      ? getScalingSize(METHODOLOGY_TEXT.paragraphGap)
                      : 0,
                }}
              >
                {paragraph}
              </Text>
            ))}
          </Box>
        ))}
      </Box>
    </Page>
  );
};

const useStyles = makeStyles<{
  getScalingSize: ReturnType<typeof useGetScalingSize>;
}>()((_theme, { getScalingSize }) => ({
  columns: {
    columnCount: METHODOLOGY_TEXT.columnCount,
    columnGap: getScalingSize(METHODOLOGY_TEXT.columnGap),
    paddingTop: getScalingSize(METHODOLOGY_TEXT.sectionGap),
  },
  section: {
    breakInside: 'avoid',
    marginBottom: getScalingSize(METHODOLOGY_TEXT.sectionGap),
  },
}));
